module.exports = __webpack_public_path__ + "img/logo-descomplica-vestibulares-escuro.e3ad7c2b.svg";